
<ng-container *ngIf="isScreenLarge; else mobileLayout">
    <mat-card-content>
  <div id="project-info">
    
    
    <div style="flex:1; max-width: 40%; display: flex;">
      <img class="edit-icon" style="margin-right: 6px; margin-left: 0px;  opacity: 0.5;" src="./assets/images/project-icon.svg">
      <span class="main-box-title-14" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;" >{{ (text_data.name && text_data.name !== 'Document 1') ? text_data.name : title }}</span>
    </div>
    <input type="text" [(ngModel)]="this.text_data.text_UID" id="PROJECT_ID_RESPALDO" hidden>
    <!-- <div class="mode-container" *ngIf="showAdvanced">
      <span [ngClass]="{'active-mode-label': checked, 'inactive-mode-label': !checked}" class="radio-label">Simple Mode</span>
      <div class="div-slide-toggle" [ngClass]="{'active-mode-div': disabled, 'inactive-mode-div': !disabled}">
        <mat-slide-toggle #check (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()" class="accent"
          [disabled]="disabled" [(ngModel)]="checked" (change)="toggleChecked()"></mat-slide-toggle>
      </div>
      <span [ngClass]="{'active-mode-label': !checked, 'inactive-mode-label': checked}"  class="radio-label" style="margin-left:5px ;">Advanced Mode</span>
    </div> -->
    
    
    <div *ngIf="showModal" class="modal">
      <p>Simple Mode not available for this tool</p>
    </div>

  </div>
  <div id="mode-switch" *ngIf="!isEyeEditing">
    <span class="label-circle" (click)="importText()">
      <span class="main-box-title-14">Import Text</span>
    </span>
    <div class="center-align">
      <span class="main-box-title-12">CEFR Level ({{ currentAnalysisMode }}): Calculated/Target</span>
      <span class="box-score" style="background-color: #F3F3F5;"><span style="opacity: 0.5;">C2/A1</span> 
        <div>
            <img (mouseenter)="openTooltipModal($event)" 
              (mouseleave)="closeTooltipModal()" style=" width: 18px; height: 18px; margin-left: 12px;" src="./assets/images/black_icons/blocked-icon.svg">
        </div>
      </span>
      <div class="tooltip-container">
        <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
        <span class="tooltip-text">The CEFR (Common European Framework of Reference for Languages) is a framework that helps describe language proficiency in a foreign language using a scale from A1 (Beginner) to C2 (Proficiency).
          <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer">
            Read more
          </a>
        </span>
      </div>
    </div>
    
  </div>

  <div id="mode-switch" *ngIf="isEyeEditing">
     <div class="message">
      <div class="line"></div>
      <p>Edit Mode active. Press the button to view the results.</p>
    </div>

      <span class="label-circle" style="width: 220px;" (click)="saveEdit()">
        <span class="main-box-title-14">Save And Update</span>
      </span>
     

    </div>
  

  <!------------------------------->
  <!-----------ALERTAS------------->
  <!---PROXIMAMENTE PARA EL LOGIN-->
  <!------------------------------->
  
  <div *ngIf="InfolimitWords" class="box-login-limit">
    <span class="main-box-title-14">Your text exceeds the 250-word limit for unregistered users. <br><u class="main-box-value-14-bold">LOGIN OR SIGN UP</u> to gain access!</span>
  </div>

    <div class="box-login" *ngIf="limitOfDocuments">
  <span class="main-box-title-14">
    A maximum of 10 documents can be processed at one time. 
    Please reduce the number of documents you are trying to process. 
    Contact 
    <a href="mailto:helpteam@textinspector.com" class="email-link">helpteam&#64;textinspector.com</a> 
    with any queries.
  </span>
</div>

   <div *ngIf="message && !isEyeEditing" class="message">
      <div class="line"></div>
      <p>Any editing of the text will result in the loss of all your previous modifications to the stats.</p>
    </div>

  <div style="text-align: center; justify-content: center;" *ngIf="!isEyeEditing">
    <span class="label-circle2" (click)="putTextSimple()">
      <img class="edit-icon" style="margin-right: 6px;" src="./assets/images/yellow_icons/copy-text-icon.svg">
      <span class="main-box-title-14" style="color: #EEA21A;">Load Sample Text</span>
    </span>
    </div>
  
  <!-- <div class="box-login">
    <span class="main-box-title-14">As this is a subscriber’s feature, you are seeing sample results. In order to  <br>see the real results of your text, <u class="main-box-value-14-bold">SUBSCRIBE NOW.</u></span>
  </div> -->

<div
  class="center-align-documents"
  #scrollContainer
  (mousedown)="startDrag($event)"
  (mousemove)="onDrag($event)"
  (mouseup)="stopDrag()"
  (mouseleave)="stopDrag()"
  (wheel)="onWheel($event)"
  *ngIf="sorted_related_projects.length > 1 && !loaderDocuments"
>
  <span
    *ngFor="let doc of sorted_related_projects"
    class="box-documents"
    [ngStyle]="{
      'background-color': '#F3F3F5',
      'border': doc.active === 'true' ? '2px solid #F5C43D' : '1px solid #73767D'
    }"
    (click)="loadRelatedProject(doc)"
  >
    {{ doc.name && doc.name.trim() !== '' ? doc.name : doc.text_UID }}
  </span>
</div>

<div style="width: auto; display: flex; justify-content: center; text-align: center; align-items: center;" *ngIf="loaderDocuments">
  <div class="loader-documents" ></div>
</div>


  <div class="text-area-shell" [ngClass]="{'text-area-locked': textInputDisabled}">
    <mat-form-field appearance="fill" style="margin-top: 0px; " id="Text-Area-Original">
      <textarea matInput rows="14" class="main-box-title-14" [(ngModel)]="text_data.text"  #textArea [readonly]="textInputDisabled" [attr.aria-disabled]="textInputDisabled"
        (input)="adjustTextareaHeight(); resetTimer(); limitWords($event)"  (focus)="clearText($event)"  id="textArea">
    </textarea>
    </mat-form-field>
    <div *ngIf="textInputDisabled" class="text-area-lock-overlay" aria-hidden="true"></div>
  </div>
  <div id="highlighted-content" style="display:none;"></div>
  <div id="highlighted-content-specific" style="display:none;"></div>
  <div class="content-copy-text">
    <button *ngIf="view_button" mat-button (click)="toggleCopyState()" [ngStyle]="{'color': buttonTextColor}">
      <img [src]="buttonImage" style="padding-right: 5px; width: 18px;">
      {{ buttonText }}
    </button>
  </div>
  <input type="file" (change)="onFileSelected($event)" accept=".txt,.doc" style="display: none;" #fileInput>
</mat-card-content>
</ng-container>

<!---------------------->
<!--------MOBILE-------->
<!---------------------->

  <ng-template #mobileLayout>
    <mat-card-content>
    <div id="project-info">
      <img *ngIf="!isEditing" class="edit-icon" style="margin-right: 6px; margin-left: 0px; opacity: 0.5;" src="./assets/images/project-icon.svg">
      
      <div style="flex:1;">
        <span class="main-box-title-14" *ngIf="!isEditing" >{{ title }}</span>
        <input *ngIf="isEditing" [(ngModel)]="title" (blur)="saveTitle()" (keypress)="onKeyPress($event)" class="editable-input"/>
      </div>

      <span class="label-circle" (click)="importText()" *ngIf="!isEyeEditing">
        <span class="main-box-title-14">Import Text</span>
      </span>
    </div>

    <!-- <div class="mode-container" *ngIf="showAdvanced">
      <span (click)="onTabClickMobile()"  [ngClass]="{'active-mode-label': checked, 'inactive-mode-label': !checked}" class="radio-label">Simple Mode</span>
      <div (click)="onTabClickMobile()" class="div-slide-toggle" [ngClass]="{'active-mode-div': disabled, 'inactive-mode-div': !disabled}" ><mat-slide-toggle #check class="accent" [disabled]="disabled" [(ngModel)]="checked" (click)="onTabClickMobile()" (change)="toggleChecked();onTabClickMobile()"></mat-slide-toggle>
      </div>
      <span [ngClass]="{'active-mode-label': !checked, 'inactive-mode-label': checked}"  class="radio-label" style="margin-left:5px ;">Advanced Mode</span>
    </div> -->

    <div *ngIf="showModalMobile" class="modal2">
      <p>Simple Mode not available for this tool</p>
    </div>

    <div id="mode-switch" *ngIf="!isEyeEditing">
      <div style="width: 1px; height: 10px;"></div>
      <div class="center-align">
        <span class="main-box-title-12">CEFR Level ({{ currentAnalysisMode }}): Calculated/Target</span>
        <span class="box-score" style="background-color: #F3F3F5;"><span style="opacity: 0.5;">C2/A1</span> 
        <div>
            <img (click)="openTooltipModalMobile($event)" style=" width: 18px; height: 18px; margin-left: 12px;" src="./assets/images/black_icons/blocked-icon.svg">
        </div>
      </span>
        <div class="tooltip-container">
          <img class="tooltip-icon" src="./assets/images/tooltip-icon.svg">
          <span class="tooltip-text">The CEFR (Common European Framework of References for Languages) is a framework that helps describe language proficiency in a foreign language using a scale from A1 (Beginner) to C2 (Proficiency). <a href="https://textinspector.com/help/tu-lexical-profile/" class="hiperlinks" target="_blank" rel="noopener noreferrer">Read more</a></span>
        </div>
      </div>
      
    </div>

    <div id="mode-switch" *ngIf="isEyeEditing">
      <div class="message">
      <div class="line" style="height: 30px;"></div>
      <p>Edit Mode active. Press the button <br>to view the results.</p>
    </div>

      <span class="label-circle" style="width: 200px;" (click)="saveEdit()">
        <span class="main-box-title-14">Save And Update</span>
      </span>
     

    </div>

    <!-----------ALERTAS------------->
    <!---PROXIMAMENTE PARA EL LOGIN-->

    <!--
    <div class="box-login">
      <span class="main-box-title-14">Your text exceeds the 250-word limit for unregistered users. <br><u class="main-box-value-14-bold">LOGIN OR SIGN UP</u> to gain access!</span>
    </div>
    -->
    <div *ngIf="InfolimitWords" class="box-login-limit">
      <span class="main-box-title-14">Your text exceeds the 250-word limit for unregistered users. <br><u class="main-box-value-14-bold">LOGIN OR SIGN UP</u> to gain access!</span>
    </div>

        <div class="box-login" *ngIf="limitOfDocuments">
  <span class="main-box-title-14">
    A maximum of 10 documents can be processed at one time. 
    Please reduce the number of documents you are trying to process. 
    Contact 
    <a href="mailto:helpteam@textinspector.com" class="email-link">helpteam&#64;textinspector.com</a> 
    with any queries.
  </span>
</div>

    <div *ngIf="message && !isEyeEditing" class="message">
      <div class="line"></div>
      <p>Any editing of the text will result in the loss of all your previous modifications to the stats.</p>
    </div>
  
    <div style="text-align: center; justify-content: center;" *ngIf="!isEyeEditing">
      <span class="label-circle2" (click)="putTextSimple()">
        <img class="edit-icon" style="margin-right: 6px;" src="./assets/images/yellow_icons/copy-text-icon.svg">
        <span class="main-box-title-14" style="color: #EEA21A;">Load Sample Text</span>
      </span>
      </div>

      
  <div class="center-align-documents" *ngIf="sorted_related_projects.length > 1 && !loaderDocuments">
  <span
    *ngFor="let doc of sorted_related_projects"
    class="box-documents"
    [ngStyle]="{
      'background-color': '#F3F3F5',
      'border': doc.active === 'true' ? '2px solid #F5C43D' : '1px solid #73767D'
    }"
    (click)="loadRelatedProject(doc)">
    {{ doc.name && doc.name.trim() !== '' ? doc.name : doc.text_UID }}
  </span>
</div>

<div style="width: auto; display: flex; justify-content: center; text-align: center; align-items: center;" *ngIf="loaderDocuments">
  <div class="loader-documents" ></div>
</div>

    <div class="text-area-shell" [ngClass]="{'text-area-locked': textInputDisabled}">
      <mat-form-field appearance="fill" style="margin-top: 0px; " id="Text-Area-Original">
        <textarea matInput rows="10" class="main-box-title-14" [(ngModel)]="text_data.text" #textArea [readonly]="textInputDisabled" [attr.aria-disabled]="textInputDisabled"
          (input)="adjustTextareaHeight();resetTimer();limitWords($event)" (focus)="clearText($event)" id="textArea">
      </textarea>
      </mat-form-field>
      <div *ngIf="textInputDisabled" class="text-area-lock-overlay" aria-hidden="true"></div>
    </div>
    <div id="highlighted-content" style="display:none;"></div>
    <div id="highlighted-content-specific" style="display:none;"></div>
    <div class="content-copy-text">
      <button *ngIf="view_button" mat-button (click)="toggleCopyState()" [ngStyle]="{'color': buttonTextColor}">
        <img [src]="buttonImage" style="padding-right: 5px; width: 18px;">
        {{ buttonText }}
      </button>
    </div>
    <input type="file" (change)="onFileSelected($event)" accept=".txt,.doc" style="display: none;" #fileInput>
  </mat-card-content>
  </ng-template>
  
